import React from 'react';
import { applyPhoneSchema, splitPhone } from '../../../utils/strings/phoneUtils';
import { useUiTheme } from 'framework/uiTheme';
import useFieldHelper from '../fieldHelper';
import { FieldProps } from '../types';

export interface PhoneFieldLayoutProps {
  label?: string;
  phone?: string;
  phoneExtension?: string;
}

export type PhoneFieldLayoutType = ReactComponent<PhoneFieldLayoutProps>;

const PhoneField = (props: FieldProps) => {
  const { getValue, getLabel } = useFieldHelper(props);
  const { PhoneFieldLayout } = useUiTheme<PhoneFieldLayoutType>();

  const value = splitPhone(getValue());

  const phone = value && applyPhoneSchema(value.phone);
  const extension = value && value.extension;

  return <PhoneFieldLayout phone={phone} phoneExtension={extension as any} label={getLabel() as string} />;
};

export default PhoneField;
